import { MouseEventHandler } from 'react'
import clsx from 'clsx'
import SmartLink from '@components/SmartLink'
import styles from './index.module.sass'

interface Props {
  id?: string;
  className?: string;
  linkUrl: string;
  text: string;
  onClick?: MouseEventHandler;
}

const UiButton = ({ id, className, linkUrl, text, onClick }: Props) => {
  return (
    <SmartLink
      id={id}
      href={linkUrl}
      className={clsx(className, styles.content)}
      onClick={onClick}
    >
      {text}
    </SmartLink>
  )
}

UiButton.defaultProps = {
  id: undefined,
  className: '',
  onClick: undefined
}

export default UiButton
